export default "__VITE_PUBLIC_ASSET__ba229fc7__"